export default "__VITE_ASSET__BBy9PG9o__"